import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import {
  BigCard,
  HalfCard,
  SmallCard,
} from "../../../../components/trendingCard";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: "30px 0px",
  },
  trend: {
    fontSize: "13px",
    letterSpacing: "3px",
    color: "#666",
    fontWeight: "700",
    textAlign: "left",
    marginBottom: "5px",
  },
  title: {
    fontSize: "23px",
    fontWeight: "bold",
    textAlign: "left",
    marginBottom: "20px",
  },
  underline: {
    paddingBottom: "4px",
    borderBottom: "1px solid #000",
  },
  card: {
    marginBottom: "15px",
  },
  img: {
    width: "100%",
    maxWidth: "400px",
    height: "auto",
  },
}));

function Trending({ title }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <p className={classes.trend}>TRENDING CATEGORY</p>
      <p className={classes.title}>
        <span className={classes.underline}>
          {title && title.substring(0, 3)}
        </span>
        {title && title.substring(3)}
      </p>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <div className={classes.card}>
            <HalfCard
              title="Smartphone of the week"
              subTitle="Samsung Galaxy S10 Plus"
            />
          </div>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <SmallCard
                title="New"
                subTitle="Xiaomi Redmi 9 Power"
                overlay="rgba(240, 58, 61,0.6)"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SmallCard
                title="New"
                subTitle="Vivo iQOO U3"
                overlay="rgba(208, 33, 224,0.6)"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
          <BigCard
            title="trending comparison"
            subTitle="Samsung Galaxy S10 Plus vs Samsung Galaxy S20 FE"
          />
        </Grid>
      </Grid>
    </div>
  );
}
export default React.memo(Trending);
